import type { TaskTargetRect } from '../engine/TaskEngine';

const MARGIN = 12;

const GAP = 12;

const BAR_BAND = 56;

const FOOTER_REACH = 24;

const NOMINAL_WIDTH = 420;

const MIN_WIDTH = 96;

const COMPACT_WIDTH = 340;

const MAX_LIFT = 220;

export function liftFor(target: TaskTargetRect | null, viewport: BarViewport): number {
  if (!target) return 0;

  const bandTop = viewport.height - MARGIN - BAR_BAND;
  const targetBottom = target.top + target.height;

  if (targetBottom <= bandTop) return 0;

  if (target.top >= viewport.height) return 0;

  const needed = viewport.height - MARGIN - target.top + GAP;
  return Math.max(0, Math.min(MAX_LIFT, Math.round(needed)));
}

export type BarDodge = 'none' | 'left' | 'right';

export interface BarPlacement {
  dodge: BarDodge;
  inset: number;
  maxWidth: number;
  compact: boolean;
  lift: number;
}

export interface BarViewport {
  width: number;
  height: number;
}

export function placeTaskBar(
  avoid: TaskTargetRect | null,
  viewport: BarViewport,
  target: TaskTargetRect | null = null,
): BarPlacement {
  void avoid;

  const full = Math.max(MIN_WIDTH, viewport.width - MARGIN * 2);
  return {
    dodge: 'none',
    inset: MARGIN,
    maxWidth: full,
    compact: false,
    lift: liftFor(target, viewport),
  };
}
